import * as firebase from 'firebase/app';
import { getFunctions } from 'firebase/functions';
// import { getAnalytics } from "firebase/analytics";  
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID 
}                                   

export const app = firebase.initializeApp(firebaseConfig);
export const functions = getFunctions(app, "asia-south1");
// export const analytics = getAnalytics(app);
// analytics.app.automaticDataCollectionEnabled = true;

export default firebase;
